module.exports = __webpack_public_path__ + "static/media/tuer_aufgabe.0500713c.jpg";